import React from 'react';
import { 
  FaUniversity,
  FaHandshake,
  FaBullhorn,
  FaChartLine,
  FaUsers,
  FaGraduationCap,
  FaGlobe,
  FaPhoneAlt,
  FaEnvelope,
  FaCheck,
  FaRocket,
  FaLightbulb,
  FaCogs,
  FaPalette,
  FaSearch,
  FaComments,
  FaStar,
  FaBullseye
} from 'react-icons/fa';
import { 
  FiMail,
  FiMessageCircle,
  FiTarget,
  FiTrendingUp
} from 'react-icons/fi';
import { 
  RiGlobalLine,
  RiTeamLine,
  RiUserStarLine
} from 'react-icons/ri';
import './EcoleUnivAfricaine.css';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const EcoleUnivAfricaine = () => {
  const serviceCategories = [
    {
      icon: <FaHandshake />,
      title: 'Partenariats académiques France ↔ Afrique',
      services: [
        { icon: <FaUniversity />, text: 'Mise en relation avec des universités et écoles françaises' },
        { icon: <FaGraduationCap />, text: 'Signature de partenariats stratégiques (double diplôme, mobilité étudiante, co-diplômation, création filiale, etc.)' }
      ]
    },
    {
      icon: <FaBullhorn />,
      title: 'Développement & Marketing',
      services: [
        { icon: <FaSearch />, text: 'Diagnostic de communication' },
        { icon: <FaLightbulb />, text: 'Mise en place d\'une stratégie digitale' },
        { icon: <FaStar />, text: 'Création d\'une offre irrésistible pour attirer plus d\'étudiants' },
        { icon: <FaPalette />, text: 'Conception de visuels : flyers, brochures, vidéos, plaquettes' },
        { icon: <FaUsers />, text: 'Organisation de salons d\'orientation et campagnes de recrutement' }
      ]
    },
    {
      icon: <FaChartLine />,
      title: 'Croissance & Recrutement',
      services: [
        { icon: <RiTeamLine />, text: 'Formation des équipes commerciales' },
        { icon: <FiTarget />, text: 'Stratégie de prospection terrain & digitale' },
        { icon: <FiTrendingUp />, text: 'Génération de leads qualifiés' },
        { icon: <FaRocket />, text: 'Augmentation du nombre d\'inscriptions' }
      ]
    }
  ];

  const createWhatsAppLink = (phone) => {
    const message = 'Bonjour Marie Claude, je suis intéressé(e) par vos services pour les établissements africains.';
    return `https://wa.me/${phone.replace(/\s/g, '')}?text=${encodeURIComponent(message)}`;
  };

  return (
    <section className="univ-africaine-sectionbigcontain">
        <Header />
    <section className="univ-africaine-section">
        
      <div className="univ-africaine-canvas">
        <div className="univ-africaine-decoration">
          {/* Particules flottantes */}
          <div className="univ-floating-particle univ-particle-1"></div>
          <div className="univ-floating-particle univ-particle-2"></div>
          <div className="univ-floating-particle univ-particle-3"></div>
          <div className="univ-floating-particle univ-particle-4"></div>
          
          {/* Lignes connectées */}
          <div className="univ-connection-line univ-line-1"></div>
          <div className="univ-connection-line univ-line-2"></div>
          
          {/* Orbes lumineuses */}
          <div className="univ-glow-orb univ-orb-1"></div>
          <div className="univ-glow-orb univ-orb-2"></div>
          <div className="univ-glow-orb univ-orb-3"></div>
        </div>
      </div>

      <div className="univ-africaine-wrapper">
        <div className="univ-africaine-header">
          <h1 className="univ-africaine-title">
            <FaGlobe className="univ-title-icon" />
            École - Université africaine
          </h1>
          <p className="univ-africaine-subtitle">
            Nous aidons les établissements africains à <span className="univ-africaine-highlight">gagner en attractivité, notoriété et croissance</span> grâce à des solutions innovantes et sur-mesure.
          </p>
        </div>

        <div className="univ-services-grid">
          {serviceCategories.map((category, index) => (
            <div 
              key={index} 
              className="univ-service-category-card"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="univ-service-category-icon-wrapper">
                <div className="univ-service-category-icon">
                  {category.icon}
                </div>
              </div>
              <h3 className="univ-service-category-title">{category.title}</h3>
              <ul className="univ-service-list">
                {category.services.map((service, idx) => (
                  <li key={idx} className="univ-service-list-item">
                    <span className="univ-service-item-icon">
                      {service.icon}
                    </span>
                    <p className="univ-service-item-text">
                      {service.text.includes('irrésistible') ? (
                        <>
                          Création d'une <span className="univ-service-item-highlight">offre irrésistible</span> pour attirer plus d'étudiants
                        </>
                      ) : service.text}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="univ-objective-box">
          <h3 className="univ-objective-title">
            <FaBullseye className="univ-objective-icon-title" />
            Notre Objectif
          </h3>
          <p className="univ-objective-text">
            Aider les universités africaines à atteindre entre <span className="univ-objective-highlight">100 et +500 nouveaux étudiants</span> par an et à s'internationaliser.
          </p>
        </div>

        <div className="univ-contact-section">
          <h2 className="univ-contact-title">
            <FaComments className="univ-contact-title-icon" />
            Contactez-nous
          </h2>
          <p className="univ-contact-instructions">
            Vous êtes intéressé par nos services ? Alors laissez-nous un message sur WhatsApp 
            et envoyez-nous un mail sur l'adresse{' '}
            <a href="mailto:etudieenfrance@gmail.com" className="univ-contact-email">
              <FiMail className="univ-email-icon" />
              etudieenfrance@gmail.com
            </a>
          </p>
          
          <a
            href={createWhatsAppLink('+33 7 49 91 11 12')}
            className="univ-whatsapp-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="univ-whatsapp-icon">
              <FiMessageCircle />
            </span>
            WhatsApp: Marie Claude (+33 7 49 91 11 12)
          </a>
          
          <p className="univ-contact-note">
            <FaPhoneAlt className="univ-phone-icon" />
            Cliquez sur le bouton pour directement laisser un message sur WhatsApp
          </p>
        </div>
      </div>
         
    </section>
     <Footer />
    </section>
  );
};

export default EcoleUnivAfricaine;